import {AbstractItem} from "./abstract-task";
import {EventType} from "../../events";
import {getCurrentUser} from "../../utils/common";
import {ActivityType} from "../../utils/consts";
import EventEmitter2 from "eventemitter2";

const ClosingStatusText = {
  CLOSE: `Закрыть`,
  OPEN: `Открыть заново`,
};

declare global {
  interface Window {
    taskEmitter: EventEmitter2;
  }
}

export class OneTask extends AbstractItem {
  private eventEmitter: EventEmitter2 = window.taskEmitter;
  private deadlineDateContainer: HTMLElement;
  private readonly deadLineDateElement: HTMLElement;
  private deadLineStartDateElement: HTMLElement;
  private readonly changeDayModalElement: HTMLElement;
  private readonly closeTaskElement: HTMLElement;
  private readonly closeTaskModalElement: HTMLElement;
  private readonly openCloseModalElement: HTMLElement;

  private closeModalOpenStatus = false;
  private closingStatus: boolean;

  constructor(item, flatpickr, type) {
    super(item, flatpickr, type);

    this.isClosingStatus = this.item.classList.contains(`one-task__block--closed`);

    this.changeDayModalElement = this.item.querySelector(`.js-modal-change-date`)!;

    this.closeTaskModalElement = this.item.querySelector(`.js-confirm-close`)!;
    this.closeTaskElement = this.item.querySelector(`.js-close-task`)!;

    this.openCloseModalElement = this.item.querySelector(`.js-task-done`)!;

    this.deadlineDateContainer = this.item.querySelector(`.js-deadline-container`)!;
    this.deadLineDateElement = this.deadlineDateContainer.querySelector(`.js-deadline-date`)!;
    this.deadLineStartDateElement = this.deadlineDateContainer.querySelector(`.js-deadline-start-date`)!;

    this.watchOpenDatePickerClickHandler = this.watchOpenDatePickerClickHandler.bind(this);
    this.watchChangeDayModalClickHandler = this.watchChangeDayModalClickHandler.bind(this);
    this.watchWindowClick = this.watchWindowClick.bind(this);
    this.watchCloseTaskElementClickHandler = this.watchCloseTaskElementClickHandler.bind(this);
    this.watchOpenCloseModalElementClickHandler = this.watchOpenCloseModalElementClickHandler.bind(this);
    this.watchCloseModalElementClickHandler = this.watchCloseModalElementClickHandler.bind(this);
  }

  getChangeDayModalElement() {
    return this.changeDayModalElement;
  }

  isChangeDayOpen() {
    return this.changeDayModalElement.classList.contains(`modal--show`);
  }

  addDeadlineNotEndClass() {
    this.deadlineDateContainer.classList.add(`one-task__date--not-end`);
  }

  removeDeadlineNotEndClass() {
    this.deadlineDateContainer.classList.remove(`one-task__date--not-end`);
  }

  removeDeadlineStartEventListener() {
    this.deadLineStartDateElement.removeEventListener(`click`, this.watchDeadlineInfoClickHandler);
  }

  isNotDeadline(): boolean {
    return this.deadlineDateContainer.classList.contains(`one-task__date--not-end`);
  }

  setFlatpickrDate(date) {
    if (date === null) {
      this.picker.clear();
    } else {
      this.picker.setDate(date, true);
    }
  }

  setActivityChangeDayModal(type) {
    switch (type) {
      case ActivityType.SHOW:
        this.changeDayModalElement.classList.add(`modal--show`);
        break;
      case ActivityType.HIDE:
        this.changeDayModalElement.classList.remove(`modal--show`);
        break;
    }
  };

  setActivityCloseTaskModal(type) {
    switch (type) {
      case ActivityType.SHOW:
        this.closeTaskModalElement.classList.add(`one-task__confirm-modal--show`);
        break;
      case ActivityType.HIDE:
        this.closeTaskModalElement.classList.remove(`one-task__confirm-modal--show`);
        break;
    }
  };

  setPriority(priority) {
    const oldPriority = this.getCurrentPriorityValue();

    super.setPriority(priority);

    const options = {
      user: getCurrentUser(),
      priority: {
        old: oldPriority,
        new: priority,
      },
    };

    this.eventEmitter.emit(`events.render`, EventType.PRIORITY, options);
  }

  setDeadlineDate(date) {
    this.deadLineDateElement.textContent = date;
  }

  setDeadlineStatusClass(status) {
    if (status === `burn`) {
      this.openElement.classList.remove(`one-task__day--current`);
      this.openElement.classList.add(`one-task__day--burn`);
    } else {
      this.openElement.classList.remove(`one-task__day--burn`);
      this.openElement.classList.add(`one-task__day--current`);
    }
  }

  setClosingStatusClass() {
    if (this.isClosingStatus) {
      this.item.classList.add(`one-task__block--closed`);
    } else {
      this.item.classList.remove(`one-task__block--closed`);
    }
  }

  setClosingButtonText() {
    const textElement = this.openCloseModalElement.querySelector(`.one-task__done-text`)!;

    if (this.isClosingStatus) {
      textElement.textContent = ClosingStatusText.OPEN;
    } else {
      textElement.textContent = ClosingStatusText.CLOSE;
    }
  }

  get isCloseModalOpen(): boolean {
    return this.closeModalOpenStatus;
  }

  set isCloseModalOpen(status: boolean) {
    this.closeModalOpenStatus = status;
  }

  get isClosingStatus(): boolean {
    return this.closingStatus;
  }

  set isClosingStatus(status) {
    this.closingStatus = status;
  }

  watchDeadlineInfoClickHandler(evt: Event) {
    evt.stopPropagation();
    super.watchDeadlineInfoClickHandler(evt);
  }

  watchChangeDayModalClickHandler(evt: Event) {
    this.callback.changeDayModalClick && this.callback.changeDayModalClick(evt);
  }

  watchOpenDatePickerClickHandler(evt: Event) {
    this.callback.openDatePickerButtonClick && this.callback.openDatePickerButtonClick(evt);
  }

  watchWindowClick(evt: Event) {
    this.callback.windowClick && this.callback.windowClick(evt);
  }

  watchCloseTaskElementClickHandler() {
    this.callback.closeTaskElementClick && this.callback.closeTaskElementClick();
  }

  watchOpenCloseModalElementClickHandler() {
    this.callback.openCloseModalClick && this.callback.openCloseModalClick();
  }

  watchCloseModalElementClickHandler(evt: Event) {
    this.callback.closeModalElementClick && this.callback.closeModalElementClick(evt);
  }

  setWindowClickHandler(callback: ((evt: Event) => void) | undefined) {
    this.callback.windowClick = callback;
    window.addEventListener(`click`, this.watchWindowClick);
  }

  setDeadLineDateElementClickHandler(callback: ((evt: Event) => void) | undefined) {
    this.callback.openDatePickerButtonClick = callback;

    if (this.userType === `admin` && this.deadLineDateElement) {
      this.deadLineDateElement.addEventListener(`click`, this.watchOpenDatePickerClickHandler);

      if (this.isNotDeadline()) {
        this.deadLineStartDateElement.addEventListener(`click`, this.watchOpenDatePickerClickHandler);
      }
    }
  }

  setChangeDayModalClickHandler(callback: ((evt: Event) => void) | undefined) {
    this.callback.changeDayModalClick = callback;

    if (this.userType === `admin`) {
      this.changeDayModalElement.addEventListener(`click`, this.watchChangeDayModalClickHandler);
    }
  }

  setOpenCloseModalClickHandler(callback: (() => void) | undefined) {
    this.callback.openCloseModalClick = callback;

    if (this.openCloseModalElement) {
      this.openCloseModalElement.addEventListener(`click`, this.watchOpenCloseModalElementClickHandler);
    }
  }

  setCloseTaskButtonClickHandler(callback: (() => void) | undefined) {
    this.callback.closeTaskElementClick = callback;

    if (this.closeTaskElement) {
      this.closeTaskElement.addEventListener(`click`, this.watchCloseTaskElementClickHandler);
    }
  }

  setCloseModalClickHandler(callback: ((evt: Event) => void) | undefined) {
    this.callback.closeModalElementClick = callback;

    if (this.closeTaskModalElement) {
      this.closeTaskModalElement.addEventListener(`click`, this.watchCloseModalElementClickHandler);
    }
  }
}
